/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/indent */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable max-lines-per-function */
import {
  Box,
  Button,
  Flex,
  Image,
  Img,
  useBoolean,
  // useToast
  useMediaQuery,
  useOutsideClick
} from "@chakra-ui/react"
import React, { createRef, useEffect, useState, type RefObject } from "react"
import { useNavigate } from "react-router"
import snapLogo from "../../assets/images/SNAPLogo-white.png"
import WarrantyFile from "../../assets/pdf/SF-QAL-TEM-23-Warranty Statement.pdf"
import { mobileBreakpoint } from "../../common/commonConstants"
import { burgerIconImg } from "../images"
import { isNewLoginUIEnabled, sanitizeUrlSegment } from "./menu.support"
import { MenuFMPButton } from "./menuFMPButton"
import { MenuBox, type MenuBoxProps } from "./menubox"
import { MobileOnlyMainMenuDropdown } from "./mobileOnlyMainMenuDropdown.dropdown.support"
import { NewAuthHeader } from "../auth/v2/NewAuthHeader"
import { ProductFilterHeaderButton } from "./productFilterHeaderButton"

export type ButtonRefType = Array<RefObject<HTMLButtonElement>>
export interface MenuItemInterface {
  name: string
  link: string
}
export type MenuBoxMasterDataType = Array<{
  menuTitle?: string
  mainMenu: string
  onclickLink: string
  id: string
  subMenu: MenuBoxProps[] | null
}>
export const SnapMenu = ({
  activeMenuCallBack,
  menuMasterData
}: {
  activeMenuCallBack: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>, value: string) => void
  menuMasterData: MenuBoxMasterDataType
}) => {
  const navigate = useNavigate()
  const dropdownRef = React.useRef<HTMLDivElement>(null)
  const closeTimeoutRef = React.useRef<ReturnType<typeof setTimeout> | null>(null)
  const [mobileMenu, setMobileMenu] = useBoolean(false)
  const [clearMenu, setClearMenu] = useState<boolean>(false)
  const [currentHoveredMenuRef, setCurrentHoveredMenuRef] = useState<RefObject<HTMLDivElement> | RefObject<HTMLButtonElement>>()
  const [subMenuData, setSubMenuData] = useState<MenuBoxProps[] | null>(null)
  const [previouslyClickedLink, setPreviouslyClickedLink] = useState<MenuItemInterface>({ name: "", link: "" })
  const [menuRefs, setMenuRefs] = useState<ButtonRefType>([])
  const [isDesktop] = useMediaQuery(`(min-width: ${mobileBreakpoint}px)`)
  const [isTouchDevice] = useMediaQuery("(hover: none)")
  const mobileContainerRef = React.useRef<HTMLDivElement>(null)

  useEffect(() => {
    setMenuRefs(menuMasterData.map(() => createRef<HTMLButtonElement>()))
  }, [])
  useOutsideClick({
    ref: dropdownRef,
    handler: () => {
      setSubMenuData(null)
    }
  })

  const startCloseTimer = (): void => {
    closeTimeoutRef.current = setTimeout(() => {
      setSubMenuData(null)
    }, 150)
  }

  const cancelCloseTimer = (): void => {
    if (closeTimeoutRef.current !== null) {
      clearTimeout(closeTimeoutRef.current)
      closeTimeoutRef.current = null
    }
  }

  useEffect(() => {
    return () => {
      if (closeTimeoutRef.current !== null) clearTimeout(closeTimeoutRef.current)
    }
  }, [])

  const handleMouseEnter = (index: number, subMenu: MenuBoxProps[] | null, menuItem?: MenuItemInterface, onclickLink?: string) => {
    cancelCloseTimer()
    if (menuItem) {
      setPreviouslyClickedLink(menuItem)
    }

    if (!clearMenu && menuRefs[index] !== currentHoveredMenuRef) {
      setClearMenu(true)
    }
    // Removes any / from the end of the link (:id)
    const sanitizedSubmenu: MenuBoxProps[] | null = subMenu
      ? subMenu.map(({ onclickLink, label, ...rest }) => ({
          onclickLink: sanitizeUrlSegment(onclickLink, label),
          label,
          ...rest
        }))
      : null
    setSubMenuData(sanitizedSubmenu)
    setCurrentHoveredMenuRef(menuRefs[index])
    if (onclickLink && !subMenu) {
      handleMenuClick(onclickLink)
    }
  }

  const handleKeyDown = (event: React.KeyboardEvent, index: number, subMenu: MenuBoxProps[] | null, onclickLink?: string) => {
    switch (event.key) {
      case "Enter":
      case " ":
        event.preventDefault()
        if (onclickLink) {
          handleMenuClick(onclickLink)
        }
        break
      case "ArrowRight": {
        event.preventDefault()
        const nextIndex = (index + 1) % menuMasterData.length
        menuRefs[nextIndex]?.current?.focus()
        break
      }
      case "ArrowLeft": {
        event.preventDefault()
        const prevIndex = index === 0 ? menuMasterData.length - 1 : index - 1
        menuRefs[prevIndex]?.current?.focus()
        break
      }
      case "ArrowDown":
        event.preventDefault()
        if (subMenu && subMenu.length > 0) {
          handleMouseEnter(index, subMenu)
        }
        break
    }
  }

  const clearAndHideMenu = (): void => {
    setClearMenu(true)
    setSubMenuData(null)
  }
  const getCurrentHoveredButtonLeftPosition = (isMobile: boolean) => {
    const getRefElement = isMobile ? mobileContainerRef : currentHoveredMenuRef
    const bb = getRefElement?.current?.getBoundingClientRect() ?? { left: 0, top: 0, height: 0 }
    const currentHoveredButtonLeftPosition = bb.left ?? 0
    const currentHoveredButtonTopPosition = bb.top + (isMobile ? 0 : bb.height)
    return { left: currentHoveredButtonLeftPosition, top: currentHoveredButtonTopPosition }
  }

  useEffect(() => {
    if (clearMenu) {
      setClearMenu(false)
    }
  }, [subMenuData, clearMenu])
  const handleMenuClick = (link: string) => {
    if (link === "WARRANTY") {
      window.open(WarrantyFile, "_blank", "noopener,noreferrer")
      clearAndHideMenu()
      setMobileMenu.off()
      return
    }
    navigate(link)
    clearAndHideMenu()
    setMobileMenu.off()
  }
  const desktopMenuHeight = React.useMemo(() => (isTouchDevice ? "56px" : "114px"), [isTouchDevice])
  return (
    <Box
      bg="primary"
      h={["56px", "56px", "56px", desktopMenuHeight]}
      zIndex={isDesktop && !isTouchDevice ? "auto" : 900}
      top={"env(safe-area-inset-top)"}
      left={"env(safe-area-inset-left)"}
      pos={isDesktop && !isTouchDevice ? "static" : "sticky"}
      width={isDesktop ? "auto" : "100%"}
    >
      <Box
        w="100%"
        margin="auto"
      >
        <Flex align={["center", "center", "center", "flex-end"]} margin="auto" maxWidth={"100%"} h={["56px", "56px", "56px", desktopMenuHeight]}>
          {(!isDesktop || isTouchDevice) && (
            <Button
              pos={"relative"}
              zIndex={101}
              m="8px"
              p="0"
              onClick={setMobileMenu.on}
              borderRadius={0}
              display="flex"
              alignItems="center"
              bg="transparent"
              aria-label="Open mobile menu"
              aria-expanded={mobileMenu}
              aria-controls="mobile-menu-dropdown"
              _focus={{
                outline: "2px solid",
                outlineColor: "white",
                outlineOffset: "2px"
              }}
            >
              <Img w="32px" m="0" src={burgerIconImg} alt="Menu" />
            </Button>
          )}

          {/* DesktopMenu */}
          {isDesktop && !isTouchDevice && (
            <>
              <Button
                onClick={() => {
                  navigate("/")
                }}
                bg="transparent"
                mt="21px"
                w="117px"
                minW="117px"
                flexShrink={0}
                h="65px"
                p="0"
                borderRadius="0"
                alignSelf={"flex-start"}
                _hover={{ bg: "transparent" }}
                aria-label="Navigate to homepage"
                _focus={{
                  outline: "2px solid",
                  outlineColor: "white",
                  outlineOffset: "2px"
                }}
              >
                <Image alt="Logo" src={snapLogo} w="117px" p="0" />
              </Button>
              <Flex align="flex-end" justifyContent={"space-between"} ml="12px" flex="1">
                <Flex role="navigation" aria-label="Main navigation" onMouseLeave={startCloseTimer} onMouseEnter={cancelCloseTimer}>
                  {menuMasterData.map(({ mainMenu, onclickLink, subMenu }, index) => (
                    <Button
                      borderRadius={0}
                      mx={["10px", "10px", "10px", "10px", "16px", "22px"]}
                      name={mainMenu}
                      p="0"
                      pl="0"
                      pb="28px"
                      variant="Button1CAPS"
                      borderColor={"accent"}
                      borderStyle={"solid"}
                      textTransform={"uppercase"}
                      key={mainMenu}
                      ref={menuRefs[index]}
                      onMouseEnter={() => {
                        handleMouseEnter(index, subMenu)
                      }}
                      onClick={() => {
                        navigate(onclickLink)
                      }}
                      onKeyDown={e => {
                        handleKeyDown(e, index, subMenu, onclickLink)
                      }}
                      aria-haspopup={subMenu ? "true" : undefined}
                      aria-expanded={subMenu && subMenuData ? "true" : "false"}
                      _hover={{
                        opacity: 0.7
                      }}
                      _focus={{
                        outline: "2px solid",
                        outlineColor: "white",
                        outlineOffset: "2px"
                      }}
                    >
                      {mainMenu}
                    </Button>
                  ))}
                </Flex>
                <Flex align="flex-end">
                  <Box mb="28px" mr="3">
                    <ProductFilterHeaderButton onNavigate={() => { setMobileMenu.off() }} />
                  </Box>
                  <Box>
                    {isNewLoginUIEnabled() ? (
                      <NewAuthHeader onNavigate={() => { setMobileMenu.off() }} ml="0" />
                    ) : (
                      <MenuFMPButton onNavigate={() => { setMobileMenu.off() }} ml="0" />
                    )}
                  </Box>
                  {/* <Search chakraProps={{ ml: '22px', mb: '28px' }} callBack={() => {}} /> */}
                </Flex>
              </Flex>
            </>
          )}

          {/* Mobile Menu */}
          {(!isDesktop || isTouchDevice) && (
            <>
              {/* The width of this flex should be 100% always. Do not set to safeWidth, 100% is required to align the logo to the middle. KS */}
              <Flex w={"100%"} justify={"center"} align={"center"} pos="absolute">
                {/* logo */}
                <Button
                  aria-description="logo"
                  onClick={() => {
                    navigate("/")
                  }}
                  bg="transparent"
                  w="67"
                  minW="67px"
                  p="0"
                  borderRadius={0}
                  alignSelf={"flex-start"}
                  _hover={{ bg: "transparent" }}
                >
                  <Image alt="Logo" aria-description="snap logo" src={snapLogo} w="67px" p="0" />
                </Button>
              </Flex>
              {mobileMenu && (
                <MobileOnlyMainMenuDropdown
                  setMobileMenu={setMobileMenu}
                  menuMasterData={menuMasterData}
                  menuRefs={menuRefs}
                  mobileContainerRef={mobileContainerRef}
                  handleMouseEnter={handleMouseEnter}
                />
              )}
            </>
          )}
        </Flex>

        {!clearMenu && (
          <Box ref={dropdownRef}>
            {subMenuData && (
              <MenuBox
                backLinkProp="All"
                menuCallBack={link => {
                  handleMenuClick(link)
                }}
                type="mainMenu"
                position={getCurrentHoveredButtonLeftPosition(mobileMenu)}
                menuBox={subMenuData}
                isMobile={mobileMenu}
                previouslyClickedLinkProp={previouslyClickedLink}
                onDropdownMouseEnter={cancelCloseTimer}
                onDropdownMouseLeave={startCloseTimer}
              />
            )}
          </Box>
        )}
      </Box>
    </Box>
  )
}